import { ChartNoAxesCombined, PackageCheck, Settings, ShieldCheck } from "lucide-react";
import { Card, PageHeader } from "../components/ui";
import type { AppView } from "../components/AppShell";

export function MorePage({ onView }: { onView(view: AppView): void }) {
  const items = [
    { id: "tools" as const, icon: PackageCheck, title: "Tools & equipment", copy: "Track ownership, purchase phases and replacement reserve." },
    { id: "plan" as const, icon: ChartNoAxesCombined, title: "12-month plan", copy: "Review monthly cash movement and funding checks." },
    { id: "settings" as const, icon: Settings, title: "Company & team", copy: "View company registration details and team access." },
  ];
  return (
    <div className="page">
      <PageHeader eyebrow="More" title="Planning and settings" description="Open the less frequent management areas." />
      <div className="more-grid">
        {items.map((item) => {
          const Icon = item.icon;
          return <button key={item.id} onClick={() => onView(item.id)}><Card><span className="more-icon"><Icon size={23} /></span><strong>{item.title}</strong><p>{item.copy}</p></Card></button>;
        })}
      </div>
      <Card className="security-note"><ShieldCheck size={23} /><div><strong>Private team workspace</strong><p>Only active users listed by the owner can read or change company data.</p></div></Card>
    </div>
  );
}
